import "./Stake.css";
import { pools } from "../../configs/configs";
import useWalletContext from "../../hooks/useWalletContext";
import usePool from "../../hooks/myHooks/pools/usePool";
import { useEffect, useState } from "react";
import useERC20Balance from "../../hooks/Web3/ERC20/useERC20Balance";
import useERC20Allowance from "../../hooks/Web3/ERC20/useERC20Allowance";
import { truncNumber } from "../../utils/NumberUtils/formatNumbers";
import DepositModal from "../../components/Modal/Modal";
import useERC20Calls from "../../hooks/Web3/ERC20/useERC20Calls";
import { ethers } from "ethers";
import { toast } from "react-toastify";
import {
  getFormattedTimeAsString,
  getShortFormattedTimeAsString,
} from "../../utils/timeUtils";

const Stake = () => {
  return (
    <div className="container stake-wrapp">
      <div className="stake-div">
        <div className="left-stake">
          <h2>
            <span>Stake</span> your <span>URUS</span> to get an{" "}
            <span>Awesome APY</span>
          </h2>

          <div className="btn-wrapp">
            <a href="#" target={"blank"}>
              <button>Buy On Pancakeswap</button>
            </a>
          </div>
        </div>
        {/* //stake box starts here------------------------ */}
        <div className="right-div">
          {pools.map((pool, index) => {
            return <StakeCard pool={pool} key={index} />;
          })}
        </div>
        {/* //stake box ends here ------------------------- */}
      </div>
    </div>
  );
};

export default Stake;

const StakeCard = ({ pool }) => {
  const walletContext = useWalletContext();
  const [busy, setBusy] = useState(false);

  const {
    poolInfo,
    userDeposits,
    userLocked,
    userUnlocked,
    deposit,
    userClaimableRewards,
    userGeneratedRewards,
    firstUnlock,
    claim,
    withdraw,
  } = usePool({
    poolAddress: pool.address,
    provider: walletContext.provider,
    decimals: pool.token.decimals,
    account: walletContext.address,
  });

  const balance = useERC20Balance({
    provider: walletContext.provider,
    userAddress: walletContext.address,
    tokenAddress: pool.token.address,
  });

  const allowance = useERC20Allowance({
    tokenAddress: pool.token.address,
    ownerAddress: walletContext.address,
    spenderAddress: pool.address,
    provider: walletContext.provider,
  });

  const ercCalls = useERC20Calls();

  const [isFinished, setIsFinished] = useState(false);
  useEffect(() => {
    setIsFinished(Number(poolInfo?.data?.rewardsLeft.value) === 0);
  }, [poolInfo]);

  const [open, setOpen] = useState(false);
  return (
    <div className="stake-box">
      <DepositModal
        open={open}
        setOpen={setOpen}
        balance={balance?.data}
        deposit={deposit}
        symbol={pool.token.symbol}
        decimals={pool.token.decimals}
      />
      <div className="stake-header">
        <p className="active-stake-tab"> Stake {isFinished && "(Finished)"}</p>
      </div>
      <div className="bottom-stake-box">
        <div className="lock-div">
          <h4>Lock duration</h4>
          <div className="time-grid">
            <button className="active-time">
              {Number(poolInfo.data?.lockPeriod)} Days
            </button>
          </div>
        </div>
        <div className="rate-div">
          <h4>
            My Stake :{" "}
            {truncNumber(
              Number(userLocked?.formatted) + Number(userUnlocked?.formatted),
              6
            )}{" "}
            $URUS
          </h4>
          <div className="apy">
            <h4>APY Rate:</h4>
            <p>{poolInfo.data?.apy?.toNumber()}%</p>
          </div>
          <div className="apy">
            <h4>Lock Period</h4>
            <p>
              {poolInfo.data?.lockPeriod
                ? Number(poolInfo.data?.lockPeriod) + " Days"
                : pool?.lockPeriod}
            </p>
          </div>
          <div className="apy">
            <h4>Claimable Every</h4>
            <p>
              {poolInfo.data?.claimPeriod
                ? Number(poolInfo.data?.claimPeriod) + " Days"
                : pool.claimPeriod}{" "}
            </p>
          </div>
          <div className="apy">
            <h4>1st Unlock in</h4>
            <p>
              {getShortFormattedTimeAsString(
                firstUnlock?.value * 1000 - Date.now()
              )}
            </p>
          </div>
          <div className="apy">
            <h4>Rewards Generated</h4>
            <p>{truncNumber(userGeneratedRewards?.formatted, 6)} $URUS</p>
          </div>

          <h4 className="balance">
            Balance: {truncNumber(balance.data?.formatted, 6)} $URUS
          </h4>
          {allowance.isSuccess && Number(allowance.data?.formatted) == 0 ? (
            <button
              disabled={
                isFinished ||
                !walletContext.isCorrectNetwork ||
                !walletContext.isConnected ||
                busy
              }
              className="approve"
              onClick={async () => {
                setBusy(true);
                try {
                  await ercCalls.approve(
                    pool.token.address,
                    walletContext.signer,
                    pool.address,
                    ethers.constants.MaxUint256
                  );
                  await allowance.refetch();
                  toast.success("Approved");
                } catch (e) {
                  toast.error(e.reason || e.message);
                } finally {
                  setBusy(false);
                }
              }}
            >
              {`Approve`}
            </button>
          ) : (
            <button
              onClick={() => setOpen(true)}
              disabled={
                isFinished ||
                !walletContext.isCorrectNetwork ||
                !walletContext.isConnected
              }
              className="approve"
            >
              {`Stake`}
            </button>
          )}
          <button
            className="approve"
            disabled={
              busy ||
              isFinished ||
              !walletContext.isCorrectNetwork ||
              !walletContext.isConnected ||
              Number(userClaimableRewards?.formatted) === 0
            }
            onClick={async () => {
              setBusy(true);
              try {
                await claim(walletContext.signer);
                await balance.refetch();
                toast.success("Claimed");
              } catch (e) {
                toast.error(e.reason || e.message);
              } finally {
                setBusy(false);
              }
            }}
          >
            Claim {`${truncNumber(userClaimableRewards?.formatted, 6)} $URUS`}
          </button>
          <button
            className="approve"
            disabled={
              busy ||
              isFinished ||
              !walletContext.isCorrectNetwork ||
              !walletContext.isConnected ||
              Number(userUnlocked?.formatted) === 0
            }
            onClick={async () => {
              setBusy(true);
              try {
                await withdraw(walletContext.signer);
                await balance.refetch();
                toast.success("Withdrawn");
              } catch (e) {
                toast.error(e.reason || e.message);
              } finally {
                setBusy(false);
              }
            }}
          >
            Withdraw {`${truncNumber(userUnlocked?.formatted, 6)} $URUS`}
          </button>
        </div>
      </div>
    </div>
  );
};
